import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("dz_cart")) || [];
    } catch {
      return [];
    }
  });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("dz_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1, openDrawer = true, note = "") => {
    setItems((prev) => {
      const key = `${product.id}|${note}`;
      const existing = prev.find((i) => (i.key || i.id) === key);
      if (existing) {
        return prev.map((i) =>
          (i.key || i.id) === key ? { ...i, qty: i.qty + qty } : i
        );
      }
      return [
        ...prev,
        {
          key,
          id: product.id,
          name: product.name,
          price: product.price,
          image: product.image,
          volume: product.volume,
          free_shipping: !!product.free_shipping,
          note,
          qty,
        },
      ];
    });
    if (openDrawer) setDrawerOpen(true);
  };

  const updateQty = (key, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => (i.key || i.id) !== key)
        : prev.map((i) => ((i.key || i.id) === key ? { ...i, qty } : i))
    );

  const removeItem = (key) => setItems((prev) => prev.filter((i) => (i.key || i.id) !== key));
  const clear = () => setItems([]);

  const { subtotal, count } = useMemo(
    () => ({
      subtotal: items.reduce((s, i) => s + i.price * i.qty, 0),
      count: items.reduce((s, i) => s + i.qty, 0),
    }),
    [items]
  );

  return (
    <CartContext.Provider
      value={{ items, addItem, updateQty, removeItem, clear, subtotal, count, drawerOpen, setDrawerOpen }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
